import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import BulkRelinquishmentConfirmationPopup from '@Components/Popups/ConfirmationPopup/BulkRelinquishmentConfirmationPopup'
import BulkActionControl from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/OverclaimBulkAction/OverclaimBulkActionControl'

const RelinquishmentBulkAction = () => {
    const { overclaimSearchBulkActionStore } = useContext(StoresContext)
    const [displayConfirmationPopup, setDisplayConfirmationPopup] = React.useState<boolean>(false)

    const isSubmitDisabled =
        overclaimSearchBulkActionStore.idsSelectedForBulkAction.size === 0 ||
        overclaimSearchBulkActionStore.idsSelectedForBulkAction.size > 100

    return (
        <>
            <BulkActionControl
                isSubmitDisabled={isSubmitDisabled}
                submitButtonText="Relinquish Selected"
                submitButtonOnClick={() => setDisplayConfirmationPopup(true)}
                instructions="Select all overclaims you wish to relinquish claims on, then click the Relinquish Selected Overclaims button."
                bulkSelectionCountText="relinquishment"
                displayConfirmationPopup={displayConfirmationPopup}
                confirmationPopup={
                    <BulkRelinquishmentConfirmationPopup onClose={() => setDisplayConfirmationPopup(false)} />
                }
            />
        </>
    )
}
export default observer(RelinquishmentBulkAction)
